<template>

  <div class="flex flex-col items-center justify-center text-center bg-cover bg-center px-4"
       :style="{ backgroundImage: `url(${require('@/assets/img/loi-master/bannerPlanet.jpg')})` }">

    <h1
        class="neon-black mt-36 font-serif text-5xl text-yellow-400 font-extrabold animate__animated animate__zoomInLeft animate__slow">
      ¡DOMINA EL MERCADO DIGITAL Y GANA DESDE EL PRIMER DÍA!
    </h1>
    <p class="neon-black text-white mt-10 text-lg animate__animated animate__zoomInRight animate__slower">
      La nueva era de los videojuegos no solo trata de jugar. <b>Ahora puedes ser el dueño de la economía del
      juego.</b>

    </p>
    <button @click.stop="mostrarInformacion()"
            class="mt-8 mb-12 inline-block px-9 py-3 text-white font-bold rounded-lg hover:text-white transition-all duration-300 gradient-bg hover:shadow-[0_0_15px_5px_rgba(255,255,0,0.7)]">
      ¡Quiero Saber Más!
    </button>
  </div>

  <div class="bg-gradient-to-r from-yellow-300 via-yellow-500 to-yellow-300 pt-1 pb-1">
  </div>

  <!-- Video de YouTube -->
  <div class="mt-14 mx-auto max-w-4xl px-6 lg:px-8">
    <div class="aspect-w-16 aspect-h-9">
      <iframe class="absolute rounded-lg  top-0 left-0 w-full h-full"
              src="https://www.youtube.com/embed/3YsmO-sBU40?si=rtDminmFAq02umHG" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
    </div>
  </div>

  <section class="p-6 px-12 flex flex-col items-center gap-6">
    <!-- Imagen -->
    <img src="@/assets/img/loi-master/logo.jpg" alt="Insignia Gestor" class="w-45 h-22">
    <!-- Texto -->
    <div class="text-center">
      <p class="text-[#714E1E] text-lg">
        Desde hoy, hasta el lanzamiento en otoño de 2025, tienes la oportunidad de <b>ser pionero en el nuevo
        modelo del gaming.</b>
        En Legends of Interaction, no solo juegas… <b> Eres dueño.</b>
      </p>
    </div>
  </section>

  <!-- En Legens Of Interactions -->
  <section class="py-8 px-6 max-w-5xl mx-auto text-center mt-8">
    <h3 class="text-3xl font-bold text-[#714E1E] mb-8"><span class="text-yellow-500">Ecosistema de juego:</span>
      cuatro mundos, una batalla</h3>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8">
      <div
          class="bg-[#90c7ca] p-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 hover:shadow-[0_4px_15px_rgba(255,255,0,0.7)]">
        <h4 class="text-xl font-bold mb-4 text-[#714E1E] stroke-white stroke-2"> <span
            class="text-yellow-500">1.</span> Mundo digital — la arena de
          los algoritmos</h4>
        <p class="text-gray-900">Bienvenido al abismo digital. Aquí mandan el código, el blockchain y el
          metaverso. No es solo un juego: es un sistema donde o te adaptas o quedas fuera. Las DAO deciden
          quién tiene el poder, la moneda del juego impone las reglas y las mecánicas determinan al realmente
          digno.</p>
      </div>
      <div
          class="bg-[#90c7ca] p-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 hover:shadow-[0_4px_15px_rgba(255,255,0,0.7)]">
        <h4 class=" text-xl font-bold mb-4 text-[#714E1E]"><span class="text-yellow-500">2.</span> Mundo social
          — el campo de las manipulaciones
        </h4>
        <p class="text-gray-900">¿Quién dijo que todo lo decide el equilibrio? El mundo lo dominan las
          alianzas, las intrigas, las guerras por territorios y las estrategias más astutas. Es un mercado
          donde no gana quien hace más clics, sino quien sabe manejar a las personas.</p>
      </div>
      <div
          class="bg-[#90c7ca] p-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 hover:shadow-[0_4px_15px_rgba(255,255,0,0.7)]">
        <h4 class=" text-xl font-bold mb-4 text-[#714E1E]"><span class="text-yellow-500">3.</span> Mundo físico
          — el mapa del juego en la realidad
        </h4>
        <p class="text-gray-900"> Ya no existen fronteras entre lo virtual y lo real. Ciudades, países, calles…
          ahora todo forma parte del juego. El GPS y la realidad aumentada han convertido el mundo en un
          terreno de juego donde cualquiera puede dejar su marca.</p>
      </div>
      <div
          class="bg-[#90c7ca] p-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 hover:shadow-[0_4px_15px_rgba(255,255,0,0.7)]">
        <h4 class=" text-xl font-bold mb-4 text-[#714E1E]"><span class="text-yellow-500">4.</span> Mundo
          económico — la caza del valor</h4>
        <p class="text-gray-900"> El dinero también es un arma. En este mundo mandan la liquidez, la economía
          dentro del juego y la posibilidad de convertirlo todo en dinero real. Aquí no solo se juega: aquí se
          construye capital.</p>
      </div>
    </div>
  </section>

  <img src="@/assets/img/loi-master/human.png" alt="Icono loi" class="h-58 mx-auto">
  <div class="py-8 px-6 max-w-5xl mx-auto text-center mb-12">
    <p class="text-2xl font-bold text-gray-900">
      Sumérgete en un mundo donde las posibilidades son infinitas.
      Interactúa con otros jugadores y objetos
      virtuales mientras
      exploras una dimensión única llena de secretos y desafíos.
    </p>
  </div>

  <!--Que a cambiado con este modelo-->
  <section
      class=" rounded-2xl p-8 max-w-6xl mx-auto mt-6 mb-8 flex flex-col md:flex-row items-center gap-8 text-white">

    <!-- Texto principal -->
    <div class="flex-1 text-center md:text-left">
      <h2 class="text-3xl text-[#714E1E] md:text-4xl font-bold">
        ¿<span class="text-yellow-400">QUÉ HA CAMBIADO</span> CON LA LLEGADA DE ESTE MODELO?
      </h2>

      <p class="mt-6 text-gray-900 leading-relaxed text-justify">
        ➡️ Los activos digitales se convirtieron en dinero — ahora puedes jugar y ganar al mismo tiempo.
      </p>

      <p class="mt-4 text-gray-900 leading-relaxed text-justify">
        ➡️ El mundo físico pasó a ser parte de la batalla — ahora las ciudades no son solo ubicaciones, son
        arenas de combate.
      </p>

      <p class="mt-4 text-gray-900 leading-relaxed text-justify">
        ➡️ La economía ahora va más allá del juego — ahora está conectada con el mundo y el mercado reales.
      </p>
    </div>

    <!-- Imagen -->
    <div class="flex">
      <img src="@/assets/img/loi-master/cuatroMundos.jpg" alt="Cacería" class="w-70 rounded-lg">
    </div>

  </section>

  <!-- Nuevo texto debajo -->
  <section class=" rounded-2xl max-w-6xl mx-auto pb-16 text-white text-center">
    <h2 class="text-[#714E1E] text-2xl font-bold mb-6">
      <span class="text-yellow-500">LEGENDS OF INTERACTIONS</span> ha roto todas las fronteras.
    </h2>

    <p class="text-gray-900 leading-relaxed max-w-3xl mx-auto">
      Ya no existe “solo un juego” — hay un nuevo mundo donde lo virtual, lo físico, lo social y lo económico
      se fusionan en una única realidad. <br/>
      ¡Bienvenido al futuro!
    </p>
  </section>


  <section
      class="w-full max-w-full md:max-w-5xl px2 mx-auto py-12 px-6 bg-[#90c7ca] text-white rounded-lg border border-yellow-500 relative shadow-lg mb-16">
    <div class="absolute top-0 left-0 transform -translate-x-2 -translate-y-2 w-3 h-3 bg-pink-500 rounded-full">
    </div>
    <div class="flex flex-col md:flex-row items-center gap-6">
      <div class="md:w-3/5">
        <h3 class="text-3xl font-bold text-[#714E1E] mb-4">POSEAN</h3>
        <p class="text-lg text-[#714E1E]">
          <strong>¡Legends of Interactions</strong> une el mundo virtual y el real! Háganse propietarios
          de prestigiosos
          terrenos en los lugares más atractivos del planeta, desde Singapur hasta México. Aprovechen
          estas oportunidades
          no solo para poseer, sino también para ganar dinero en un universo de juego en rápido
          desarrollo. ¡Aquí su éxito
          no tiene límites!
        </p>
      </div>
      <div class="md:w-2/5">
        <img src="@/assets/img/loi-master/own.jpg" alt="Mapa del juego"
             class="rounded-lg shadow-lg border border-yellow-400 transform hover:scale-105 transition">
      </div>
    </div>
  </section>

  <!-- elijan su experiencia -->
  <div class="bg-gradient-to-r from-yellow-300 via-yellow-500 to-yellow-300 pt-1 pb-1">
  </div>
  <div class=" flex flex-col text-center items-center justify-center min-h-screen text-white px-6 bg-cover bg-center"
       :style="{ backgroundImage: `url(${require('@/assets/img/loi-master/bannerAzul.jpg')})` }">
    <img src="@/assets/img/loi-master/logo.jpg" alt="Icono loi" class="h-28 mx-auto">
    <h2 class="neon-black text-3xl font-bold text-yellow-400 mb-6 relative">
      ELIJAN SU ROL DE EXPERIENCIA
      <span class="absolute -top-2 left-1/2 -translate-x-1/2 w-2 h-2 bg-pink-500 rounded-full"></span>
    </h2>
    <div class="flex flex-col md:flex-row gap-6 w-full max-w-4xl">
      <!-- Creadores de mercado -->
      <div
          class="flex-1 bg-[#1C2541] p-6 rounded-lg shadow-lg border border-gray-600 transition-transform transform hover:scale-105 hover:shadow-[0_4px_15px_rgba(255,255,0,0.7)]">
        <h3 class="text-2xl font-bold">MARKET MAKERS</h3>
        <h4 class="text-yellow-400 font-bold mb-4">Negocio basado en un juego</h4>
        <p class="text-gray-300">
          Creen orbes y objetos, pónganlos a la venta en el Marketplace, gestionen el negocio en la
          franquicia del juego y obtengan
          <span class="font-bold">remuneraciones.</span>
        </p>
        <p class="text-green-400 font-bold mt-4">✅ ¡Abierto ahora! Participa hoy.</p>
      </div>

      <!-- Masters Card -->
      <div
          class="flex-1 bg-[#1C2541] p-6 rounded-lg shadow-lg border border-gray-600 transition-transform transform hover:scale-105 hover:shadow-[0_4px_15px_rgba(255,255,0,0.7)]">
        <h3 class="text-2xl font-bold">MASTERS OF GAME</h3>
        <h4 class="text-yellow-400 font-bold mb-4">Plataforma del Juego como negocio</h4>
        <p class="text-gray-300">
          Diseñen y moldea el espacio del juego, comercia con tierras, recursos y otros objetos del juego,
          emprende en
          el negocio de publicidad dentro del mundo del juego y genera ingresos através de las
          interacciones en tu
          tierra virtual.
        </p>
        <p class="text-green-400 font-bold mt-4">✅ ¡Abierto ahora! Participa hoy.</p>
      </div>

      <!-- Player Card -->
      <div class="flex-1 bg-[#1C2541] p-6 rounded-lg shadow-lg border border-gray-600 opacity-80">
        <h3 class="text-2xl font-bold">PLAYER</h3>
        <h4 class="text-yellow-400 font-bold mb-4">El juego como fuente de aventuras</h4>
        <p class="text-gray-300">
          Disfruta del proceso del juego, explora un mundo de oportunidades únicas, recibe experiencia de
          juego
          totalmente diferente y colecciona raros objetos digitales.
        </p>
        <p class="text-red-400 font-bold mt-4">🚧 Próximamente: Apertura en otoño 2025.</p>
      </div>
    </div>

    <!-- Botón -->
    <button @click.stop="mostrarInformacion()"
            class="mt-8 mb-12 bg-yellow-400 text-gray-900 font-bold py-3 px-8 rounded-full text-lg shadow-lg hover:scale-105 transition-transform">
      Quiero formar parte de <span class="text-blue-800">Legens Of Interactions</span>
    </button>
  </div>

  <div class="bg-gradient-to-r from-yellow-300 via-yellow-500 to-yellow-300 pt-1 pb-1">
  </div>

  <!-- Video de YouTube -->
  <div class="pt-8">
    <div class="mx-auto max-w-5xl px-6 lg:px-8">
      <div class="aspect-w-16 aspect-h-9">
        <iframe class="absolute rounded-lg  top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed/WvxL5i44DYI?si=t495ihbG1dQGe_hx" frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
      </div>
    </div>
  </div>

  <!-- blockchain netsbo-->
  <section
      class="w-full max-w-full md:max-w-5xl px2 mx-auto py-12 px-6 bg-[#90c7ca] text-white rounded-lg border border-yellow-500 relative shadow-lg mt-12 mb-16">
    <div class="absolute top-0 left-0 transform -translate-x-2 -translate-y-2 w-3 h-3 bg-pink-500 rounded-full">
    </div>
    <div class="flex flex-col md:flex-row items-center gap-6">
      <div class="md:w-3/5">
        <h3 class="text-3xl font-bold text-[#714E1E] mb-4">Un Ecosistema Impulsado por Blockchain</h3>
        <p class="text-lg text-[#714E1E]">
          Legends of Interactions integra el blockchain <b>NETSBO</b>, permitiendo una economía
          descentralizada y segura. Conecta tus activos con el
          marketplace <b>Antallagí.io</b> y lleva tu experiencia de juego al siguiente nivel con recursos
          tokenizados que realmente tienen valor.
          <b>Ganar dentro del juego nunca había sido tan real.</b>
        </p>
      </div>
      <div class="md:w-2/5">
        <img src="@/assets/img/loi-master/netsbo-logo.jpg" alt="Mapa del juego"
             class="rounded-lg shadow-lg border border-yellow-400 p-4 transform hover:scale-105 transition">
      </div>
    </div>
  </section>

  <!-- Llamada a la acción -->
  <div class="bg-gradient-to-r from-yellow-300 via-yellow-500 to-yellow-300 pt-1 pb-1">
  </div>
  <div class="bg-gray-600 py-16 bg-cover bg-center relative z-20"
       :style="{ backgroundImage: `url(${require('@/assets/img/loi-master/bannerPlanet.jpg')})` }">
    <!-- CTA -->
    <section class="max-w-3xl mx-auto text-center py-12 px-6">
      <h2 class="neon-text font-serif text-4xl font-bold text-gray-800"> ¡Sé de los Primeros en un Mundo Nuevo!
      </h2>
      <p class="neon-black mt-4 text-lg text-white">👉 No te quedes fuera. Contáctanos ahora mismo por WhatsApp y
        sé de los primeros en explorar este mundo único.</p>

      <button @click.stop="mostrarInformacion()"
              class="mt-18 mb-12 inline-block px-9 py-3 text-white font-bold rounded-lg hover:text-white transition-all duration-300 gradient-bg hover:shadow-[0_0_15px_5px_rgba(255,255,0,0.7)]">
        📲 Chatea con un asesor
      </button>


      <p class="neon-text font-serif mt-4 text-lg text-blue-900 font-bold">Legends of Interactions — La Frontera
        Entre
        la Realidad y lo Digital.</p>
    </section>
  </div>
  <div class="bg-gradient-to-r from-yellow-300 via-yellow-500 to-yellow-300 pt-1 pb-1">
  </div>

  <div ref="modalContacto" class="hidden">
    <div style="color: #1e293b; font-family: 'Segoe UI', sans-serif; animation: fadeInZoom 0.5s ease;">
      <div style="margin-bottom: 1rem; text-align: center;">
        <h2 style="font-size: 1.8rem; font-weight: 700;">{{ participante.nombre || 'Sin nombre' }}</h2>
        <p style="color: #64748b; font-size: 0.95rem;">Información de contacto y enlaces</p>
      </div>
      <div style="padding: 1rem; text-align: left; background-color: #f1f5f9; border-radius: 10px;">
        <p style="margin-bottom: 10px;" v-if="participante.telefono">
          <strong>📲 WhatsApp: </strong>
          <a :href="`https://api.whatsapp.com/send?phone=521${participante.telefono}&text=¡Hola!%20Estoy%20interesado%20en%20conocer%20más%20sobre%20Legends%20of%20Interactions.%20¿Me%20puedes%20dar%20más%20información?`"
             target="_blank" class="text-blue-700">
            <i class="fa-brands fa-whatsapp mr-1"></i>{{ participante.telefono }}
          </a>
        </p>
        <p style="margin-bottom: 10px;" v-if="participante.dato_identificacion">
          <strong>🪪 Datos de identificación: </strong>{{ participante.dato_identificacion }}
        </p>
        <p style="margin-bottom: 10px;" v-if="participante.web_url">
          <strong>🌐 Sitio Web: </strong>
          <a :href="participante.web_url" target="_blank" class="text-blue-700">{{ participante.web_url }}</a>
        </p>
        <p style="margin-bottom: 10px;" v-if="participante.registro_url">
          <strong>📝 Enlace de registro LOI: </strong>
          <a :href="participante.registro_url" target="_blank" class="text-blue-700">
            {{ participante.registro_url }}
          </a>
        </p>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'loi-master4',
  props: {
    participante: {
      type: Object,
      default() {
        return {
          nombre: 'Virtual Shoppin Club',
          telefono: "4271615141",
          dato_identificacion: "",
          web_url: "https://virtualshoppingclub.com",
          registro_url: "https://virtualshoppingclub.com/registro",
        };
      }
    },
    sinParticipantes: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    mostrarInformacion() {
      this.$emit('set-click')

      // Mostrar el modal con SweetAlert2
      this.$swal({
        title: 'Tu Asesor',
        html: this.$refs.modalContacto.innerHTML,
        confirmButtonText: 'Cerrar',
        confirmButtonColor: '#D20103',
        background: '#FFFFFF',
        showClass: {
          popup: 'swal2-show-animate'
        },
        customClass: {
          popup: 'rounded-xl'
        },
        didOpen: () => {
          const style = document.createElement('style')
          style.innerHTML = `@keyframes fadeInZoom {
            0% { opacity: 0; transform: scale(0.9); }
            100% { opacity: 1; transform: scale(1); }
          }`
          document.head.appendChild(style)
        }
      })
    }
  }
}
</script>

<style scoped>
.neon-text {
  text-shadow: 0 0 0px #ffffff, 0 0 10px #ffffff, 0 0 10px #ffffff;
}

.neon-black {
  text-shadow: 0 0 20px #000000, 0 0 10px #000000, 0 0 20px #000000;
}

.neon-gradiente {
  text-shadow: 0 0 0px #000000, 0 0 20px #000000, 0 0 50px #000000;
}

.neon-borde {
  text-shadow: 0 0 0px #ffffff, 0 0 0px #ffffff, 0 0 0px #ffffff;
}
</style>